"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var htmlMediaEvents = {
  progress: 'progress',
  timeupdate: 'timeupdate',
  play: 'play',
  playing: 'playing',
  waiting: 'waiting',
  ended: 'ended',
  error: 'error',
  seeked: 'seeked'
};
var _default = exports["default"] = htmlMediaEvents;
//# sourceMappingURL=htmlMediaEvents.js.map